/* mega-menu.js — desktop mega panel keyboard and aria-expanded.
   Hover open/close stays in assets/chrome.css, including the #124 intent
   delay (fine pointers only, after html.mega-intent) and the close fade.
   This file does not open a panel on hover. It toggles aria-expanded,
   moves focus, and adds classes so Esc and pointer-leave can close a
   panel that focus would otherwise keep open. The mobile drawer is separate. */
(function () {
  'use strict';

  if (window.__puMegaMenu) return;
  window.__puMegaMenu = true;
  /* html.js is set in the head before this file runs. Gate the keyboard CSS
     on mega-js so a failed or pending script matches main: focus-within opens. */
  document.documentElement.classList.add('mega-js');

  var OPEN_DELAY = 150;
  /* Only while the pointer crosses header padding between the trigger and the
     panel. A real leave (outside the header, or into another item) closes now. */
  var GAP_GRACE = 120;
  var ignoringFocus = false;

  function desktop() {
    var root = document.documentElement;
    /* Burger row: the nav is not on screen, so hover and keyboard must not open a panel. */
    if (root.classList.contains('header-compact')) return false;
    if (root.classList.contains('js') && !root.classList.contains('header-ready')) return false;
    return window.matchMedia('(min-width: 1200px)').matches;
  }

  function fineHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function itemFrom(node) {
    return node && node.closest ? node.closest('.site-header .mega') : null;
  }

  function triggerOf(item) {
    return item.querySelector('a.site-header__nav-link[aria-haspopup]');
  }

  function panelOf(item) {
    return item.querySelector('.mega__panel');
  }

  function clearTimer(item) {
    if (!item._megaTimer) return;
    clearTimeout(item._megaTimer);
    item._megaTimer = 0;
  }

  function cancelLeave(item) {
    if (!item._megaLeave) return;
    clearTimeout(item._megaLeave);
    item._megaLeave = 0;
  }

  function sync(item) {
    var trigger = triggerOf(item);
    if (!trigger) return;
    var open = false;
    if (!item.classList.contains('is-dismissed')) {
      if (item.classList.contains('is-open')) open = true;
      else if (item.getAttribute('data-mega-hover') === 'open' && item.matches(':hover')) open = true;
    }
    var next = open ? 'true' : 'false';
    if (trigger.getAttribute('aria-expanded') !== next) trigger.setAttribute('aria-expanded', next);
  }

  function closeOthers(current) {
    var nodes = document.querySelectorAll('.site-header .mega.is-open');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i] === current) continue;
      nodes[i].classList.remove('is-open');
      sync(nodes[i]);
    }
  }

  /* -1: fine pointer, intent not armed yet, so CSS will not open either. */
  function hoverDelay() {
    if (!fineHover()) return 0;
    if (!document.documentElement.classList.contains('mega-intent')) return -1;
    if (reducedMotion()) return 0;
    return OPEN_DELAY;
  }

  function commitHover(item) {
    if (!item.matches(':hover') || item.classList.contains('is-dismissed')) return;
    if (fineHover() && !document.documentElement.classList.contains('mega-intent')) return;
    item.setAttribute('data-mega-hover', 'open');
    sync(item);
  }

  function scheduleHover(item) {
    if (!desktop() || item.classList.contains('is-dismissed')) return;
    if (item.getAttribute('data-mega-hover') === 'open' || item._megaTimer) return;
    var delay = hoverDelay();
    if (delay < 0) return;
    if (delay === 0) {
      commitHover(item);
      return;
    }
    item._megaTimer = window.setTimeout(function () {
      item._megaTimer = 0;
      commitHover(item);
    }, delay);
  }

  function panelIsOpen(item) {
    if (item.classList.contains('is-dismissed')) return false;
    if (item.classList.contains('is-open')) return true;
    if (item._megaTimer && item.matches(':hover')) return true;
    if (item.getAttribute('data-mega-hover') === 'open' && item.matches(':hover')) return true;
    if (!fineHover() && item.matches(':hover')) return true;
    return false;
  }

  function firstLink(item) {
    var panel = panelOf(item);
    return panel ? panel.querySelector('a[href]') : null;
  }

  function openFromInput(item, focusFirst) {
    if (!desktop() || ignoringFocus) return;
    cancelLeave(item);
    item.classList.remove('is-dismissed');
    item.classList.add('is-open');
    closeOthers(item);
    sync(item);
    if (!focusFirst) return;
    var panel = panelOf(item);
    var link = firstLink(item);
    if (!panel || !link) return;
    /* content-visibility stays hidden until the open style is committed, so
       the first focus() can miss. Retry across a couple of frames. */
    var tries = 0;
    function attempt() {
      if (!item.classList.contains('is-open') || !link.isConnected) return;
      panel.getBoundingClientRect();
      link.focus({ preventScroll: true });
      if (document.activeElement === link || tries >= 3) return;
      tries += 1;
      window.requestAnimationFrame(attempt);
    }
    attempt();
  }

  function releaseKeyboard(item) {
    var trigger = triggerOf(item);
    var panel = panelOf(item);
    var active = document.activeElement;
    var inPanel = !!(panel && active && panel.contains(active));
    item.classList.remove('is-open');
    item.removeAttribute('data-mega-hover');
    if (inPanel && trigger) {
      ignoringFocus = true;
      trigger.focus({ preventScroll: true });
      ignoringFocus = false;
    }
    sync(item);
  }

  function dismiss(item) {
    var trigger = triggerOf(item);
    cancelLeave(item);
    clearTimer(item);
    item.removeAttribute('data-mega-hover');
    item.classList.remove('is-open');
    item.classList.add('is-dismissed');
    sync(item);
    if (trigger) {
      ignoringFocus = true;
      trigger.focus({ preventScroll: true });
      ignoringFocus = false;
    }
    /* Pointer is elsewhere: don't latch, or the next hover could not open.
       Focus is back on the trigger, and :focus-within no longer pins it open. */
    if (!item.matches(':hover')) item.classList.remove('is-dismissed');
  }

  function headerGap(item, related) {
    if (!related || !related.closest) return false;
    if (item.contains(related)) return false;
    if (related.closest('.site-header .mega')) return false;
    var header = item.closest('.site-header');
    return !!(header && header.contains(related));
  }

  function onLeave(item, related) {
    clearTimer(item);
    if (!fineHover()) {
      window.requestAnimationFrame(function () {
        if (!item.isConnected) return;
        /* A tap can end the pointer event while :hover stays. Only a real
           leave (:hover false) drops the keyboard hold. */
        if (item.matches(':hover') && !item.classList.contains('is-dismissed')) {
          item.setAttribute('data-mega-hover', 'open');
          sync(item);
          return;
        }
        item.classList.remove('is-dismissed');
        item.removeAttribute('data-mega-hover');
        releaseKeyboard(item);
      });
      return;
    }

    if (!item.classList.contains('is-open')) {
      cancelLeave(item);
      item.removeAttribute('data-mega-hover');
      /* Esc latches while the pointer is still over the trigger. Keep that
         latch across the header padding and the panel, and drop it only once
         the pointer actually leaves the menu. */
      if (item.classList.contains('is-dismissed') && headerGap(item, related)) {
        sync(item);
        return;
      }
      if (!headerGap(item, related)) item.classList.remove('is-dismissed');
      sync(item);
      return;
    }

    if (!headerGap(item, related)) {
      cancelLeave(item);
      item.classList.remove('is-dismissed');
      releaseKeyboard(item);
      return;
    }

    if (item._megaLeave) return;
    item._megaLeave = window.setTimeout(function () {
      item._megaLeave = 0;
      if (item.matches(':hover')) {
        if (!item.classList.contains('is-dismissed')) item.setAttribute('data-mega-hover', 'open');
        sync(item);
        return;
      }
      item.classList.remove('is-dismissed');
      releaseKeyboard(item);
    }, GAP_GRACE);
  }

  document.addEventListener('pointerover', function (e) {
    var item = itemFrom(e.target);
    if (!item || !desktop()) return;
    var from = e.relatedTarget;
    if (from && item.contains(from)) return;
    /* pointerenter from outside the item (pointerenter does not bubble).
       Drop a stuck Esc latch so the next hover can open. */
    if (item.classList.contains('is-dismissed')) {
      item.classList.remove('is-dismissed');
      sync(item);
    }
    cancelLeave(item);
    scheduleHover(item);
  });

  /* Leaving through nav or header padding does not leave the item in a way
     that drops the latch. Leaving the header itself always does. */
  var headers = document.querySelectorAll('.site-header');
  for (var h = 0; h < headers.length; h++) {
    headers[h].addEventListener('pointerleave', function () {
      var stuck = this.querySelectorAll('.mega.is-dismissed');
      for (var i = 0; i < stuck.length; i++) {
        stuck[i].classList.remove('is-dismissed');
        sync(stuck[i]);
      }
    });
  }

  document.addEventListener('pointerout', function (e) {
    var item = itemFrom(e.target);
    if (!item || !desktop()) return;
    var to = e.relatedTarget;
    if (to && item.contains(to)) return;
    onLeave(item, to);
  });

  /* Intent is armed on pointermove (capture, in the layout). Schedule aria
     on the same move so it lines up with the CSS delay. Later moves no-op. */
  document.addEventListener('pointermove', function (e) {
    if (!desktop() || !fineHover()) return;
    if (!document.documentElement.classList.contains('mega-intent')) return;
    var item = itemFrom(e.target);
    if (!item) return;
    scheduleHover(item);
  }, { capture: true, passive: true });

  document.addEventListener('focusin', function (e) {
    var item = itemFrom(e.target);
    if (!item || !desktop()) return;
    openFromInput(item, false);
  });

  document.addEventListener('focusout', function (e) {
    var item = itemFrom(e.target);
    if (!item || !desktop()) return;
    var next = e.relatedTarget;
    if (next && item.contains(next)) return;
    cancelLeave(item);
    clearTimer(item);
    item.classList.remove('is-open');
    item.removeAttribute('data-mega-hover');
    /* Focus left the trigger and the panel. Close even if the pointer is
       still inside; the latch drops on the next pointer leave. */
    if (item.matches(':hover')) item.classList.add('is-dismissed');
    else item.classList.remove('is-dismissed');
    sync(item);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'ArrowDown') return;
    if (e.altKey || e.metaKey || e.ctrlKey) return;
    var item = itemFrom(e.target);
    if (!item || !desktop()) return;

    if (e.key === 'Escape') {
      if (!panelIsOpen(item)) return;
      e.preventDefault();
      dismiss(item);
      return;
    }

    if (e.target !== triggerOf(item)) return;
    e.preventDefault();
    openFromInput(item, true);
  });
})();
